<template>
    <div class="post-component" :class="{ 'post-component--featured': post.featured }">
        <div class="post-component-image">
            <img v-if="post.logoUrl" :src="post.logoUrl" :alt="post.companyName">
            <img v-else-if="post.logoImage" :src="post.logoImage" :alt="post.companyName">
            <a :href="post.url" class="btn btn--ghost btn--mini">View job</a>
        </div>

        <div class="post-component-description">
            <p v-if="post.featured" class="h6 mb-xs text--orange">Featured</p>
            <p class="h4 mb-xs">{{ post.title }}</p>
            <p class="mb-sm">{{ post.companyName }}</p>
            <p class="small mb-md"><strong class="mr-xs">Closing date</strong> {{ post.closingDate }}</p>
            <p>{{ post.contentSummary }}</p>
        </div>

        <div class="post-component-info">
            <a :href="post.url" class="btn btn--ghost mb-md">View job</a>

            <ul>
                <li v-if="post.employmentType.length">
                    <strong>Employment Type</strong>
                    {{ post.employmentType[0] }}
                </li>
                <li v-if="post.technologyType.length">
                    <strong>Technology</strong>
                    {{ post.technologyType[0] }}
                </li>
                <li v-if="post.seniorityLevel.length">
                    <strong>Seniority Level</strong>
                    {{ post.seniorityLevel[0] }}
                </li>
                <li v-if="post.minSalary || post.maxSalary">
                    <strong>Salary</strong>
                    {{ post.minSalary }} - {{ post.maxSalary }}
                </li>
                <li v-if="post.state.length">
                    <strong>State</strong>
                    {{ post.state[0] }}
                </li>
                <li v-if="post.city">
                    <strong>Location</strong>
                    {{ post.city }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        post: {
            type: Object,
            required: true
        }
    },
};
</script>

<style lang="scss" scoped>
    .post-component {
        display: flex;
        padding: 3em;
        border: 1px solid #DDDDDD;
        box-shadow: 0 1px 3px #DDDDDD;
        margin-bottom: 2em;

        @media screen and (max-width:768px) {
            flex-direction: column;
            padding: 1.5em 1em;
        }
    }

    .post-component-image {
        flex-shrink: 0;
        // width: 100px;

        @media screen and (max-width:768px) {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1em;
        }

        img {
            width: 100px;
        }

        a {
            @media screen and (min-width:769px) {
                display: none !important;
            }
        }
    }

    .post-component-description {
        flex-grow: 1;
        margin: 0 3em;

        @media screen and (max-width:768px) {
            margin: 0 0 2em;
        }
    }

    .post-component-info {
        flex-basis: 210px;
        font-size: 14px;
    
        .btn {
            margin-bottom: 1em;

            @media screen and (max-width:768px) {
                display: none !important;
            }
        }

        ul {
            @media screen and (min-width: 420px) and (max-width:768px) {
                display: flex;
                flex-wrap: wrap;
            }

            li {
                margin-bottom: 0.5em;

                @media screen and (min-width: 420px) and (max-width:768px) {
                    width: 48%;
                    margin-right: 2%;
                }
            }

            strong {
                display: block;
            }
        }
    }


    .post-component--featured {
        @media screen and (max-width:768px) {
            border-top: 8px solid #EF6E0B;
        }

        @media screen and (min-width:769px) {
            border-left: 8px solid #EF6E0B;
        }
    }
</style>
